"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SinglePriceAwareUpgradeable__factory = void 0;
var ethers_1 = require("ethers");
var SinglePriceAwareUpgradeable__factory = /** @class */ (function (_super) {
    __extends(SinglePriceAwareUpgradeable__factory, _super);
    function SinglePriceAwareUpgradeable__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SinglePriceAwareUpgradeable__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SinglePriceAwareUpgradeable__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SinglePriceAwareUpgradeable__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SinglePriceAwareUpgradeable__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SinglePriceAwareUpgradeable__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return SinglePriceAwareUpgradeable__factory;
}(ethers_1.ContractFactory));
exports.SinglePriceAwareUpgradeable__factory = SinglePriceAwareUpgradeable__factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newSigner",
                type: "address",
            },
        ],
        name: "TrustedSignerChanged",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_trustedSigner",
                type: "address",
            },
        ],
        name: "authorizeSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getTrustedSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxDelay",
                type: "uint256",
            },
        ],
        name: "setMaxDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=SinglePriceAwareUpgradeable__factory.js.map